import { AuviousRtcRedux } from "./reduxImpl/AuviousRtcRedux";
export { ConferenceMode } from "./reduxImpl/conference/model";
export class StreamTypes {
}
StreamTypes.MIC = "mic";
StreamTypes.CAM = "cam";
StreamTypes.VIDEO = "video";
StreamTypes.SCREEN = "screen";
StreamTypes.UNKNOWN = "unknown";
/**
 * Use this to create an AuviousRtc instance.
 */
export class AuviousRtcFactory {
    static create() {
        return new AuviousRtcRedux();
    }
}
